export default __webpack_public_path__ + "06b681aaf2d5441a3795aaa94fc3e397.png";